import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LocaleKeys from '../../../../locales/keys';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  additionalPadding: {
    paddingTop: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(0),
    },
  },
  sharedMessage: {
    textAlign: 'center',
    color: '#FFFF',
    fontSize: '28px',
    fontStyle: 'normal',
    lineHeight: '38px',
    fontFamily: 'Formula1-Black',

    [theme.breakpoints.down('md')]: {
      fontSize: '22px',
      lineHeight: '36px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
      lineHeight: '36px',
    },
  },
  retentionMessage: {
    fontWeight: '500',
  },
  offerMessage: {
    paddingLeft: '10px',
    paddingRight: '10px',
    marginLeft: '10px',
    marginRight: '10px',
    backgroundColor: '#0092E1',
    borderRadius: '4px',
    fontWeight: '900',
  },
}));

const RetentionMessage = (props) => {
  const { discountDetails } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Typography
        className={`${classes.sharedMessage} ${classes.retentionMessage} ${classes.additionalPadding}`}
      >
        {t(LocaleKeys.retention.retentionMessageLine1)}
      </Typography>
      <div style={{ display: 'flex' }}>
        <Typography
          className={`${classes.sharedMessage} ${classes.retentionMessage}`}
        >
          {t(LocaleKeys.retention.retentionMessageLine2Prefix)}
        </Typography>
        <Typography
          className={`${classes.sharedMessage} ${classes.offerMessage}`}
        >
          {t(LocaleKeys.retention.retentionMessageLine2Amount, {
            discountAmount: discountDetails?.DiscountAmount,
          })}
        </Typography>
        <Typography
          className={`${classes.sharedMessage}
          ${classes.retentionMessage}`}
        >
          {discountDetails?.DiscountPeriod === 1
            ? t(LocaleKeys.retention.retentionMessageLine2SuffixSingular, {
                discountPeriod: discountDetails?.DiscountPeriod,
              })
            : t(LocaleKeys.retention.retentionMessageLine2SuffixPlural, {
                discountPeriod: discountDetails?.DiscountPeriod,
              })}
        </Typography>
      </div>
      <Typography
        className={`${classes.sharedMessage} ${classes.retentionMessage}`}
      >
        {discountDetails?.DiscountPeriod === 1
          ? t(LocaleKeys.retention.retentionMessageLine3Singular, {
              discountPeriod: discountDetails?.DiscountPeriod,
            })
          : t(LocaleKeys.retention.retentionMessageLine3Plural, {
              discountPeriod: discountDetails?.DiscountPeriod,
            })}
      </Typography>
    </>
  );
};

export default RetentionMessage;
